var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("div", { staticClass: "menu-label" }, [
          _c("div", { staticClass: "columns is-gapless" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "span",
                {
                  staticClass: "title is-6",
                  staticStyle: { "white-space": "nowrap" },
                },
                [_vm._v(" " + _vm._s(_vm.templateName) + " ")]
              ),
            ]),
          ]),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: { name: _vm.routeTypes.QuoteTemplateLabourView.name },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", {}, [_vm._v("Labour")])]
              ),
            ],
            1
          ),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: { name: _vm.routeTypes.QuoteTemplateMiscView.name },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", {}, [_vm._v("Misc")])]
              ),
            ],
            1
          ),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: { name: _vm.routeTypes.QuoteTemplateSubletView.name },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", {}, [_vm._v("Sublet")])]
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }